import classNames from 'classnames';
import { PropTypes as MobxPropTypes, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../i18n/globalTranslations';
import Language from '../../../models/Language';
import { modelOf } from '../../../prop-types';
import { countryCodeFromLocale } from '../../../util/languageMapper';
import LocaleFlagIcon from '../LocaleFlagIcon';

const LABEL_ID = 'regional-settings-inline-language-selector-label';

const RegionalSettingsInlineLanguageSelector = ({
  language,
  languages,
  onSelect,
  disabled,
}) => {
  return (
    <div
      className="RegionalSettingsInlineLanguageSelector"
      role="group"
      aria-labelledby={LABEL_ID}
    >
      <span id={LABEL_ID} className="sr-only">
        <FormattedMessage
          {...globalTranslations.languageLabel}
          values={{ language: language.name }}
        />
      </span>
      {languages.map((languageOption) => {
        const isActive = language.code === languageOption.code;

        if (isActive) {
          return (
            <span
              key={languageOption.code}
              className={classNames(
                'RegionalSettingsInlineLanguageSelector__item',
                'RegionalSettingsInlineLanguageSelector__item--active'
              )}
              aria-current="true"
            >
              <span className="sr-only">
                <FormattedMessage
                  {...globalTranslations.languageLabel}
                  values={{ language: languageOption.name }}
                />
              </span>
              <LocaleFlagIcon
                locale={countryCodeFromLocale(languageOption.code)}
                decorative
              />
            </span>
          );
        }

        return (
          <button
            key={languageOption.code}
            type="button"
            className="RegionalSettingsInlineLanguageSelector__item"
            disabled={disabled}
            onClick={() => onSelect(languageOption)}
          >
            <span className="sr-only">
              <FormattedMessage
                {...globalTranslations.languageLabel}
                values={{ language: languageOption.name }}
              />
            </span>
            <LocaleFlagIcon
              locale={countryCodeFromLocale(languageOption.code)}
              decorative
            />
          </button>
        );
      })}
    </div>
  );
};

RegionalSettingsInlineLanguageSelector.propTypes = {
  language: modelOf(Language).isRequired,
  languages: MobxPropTypes.observableArrayOf(modelOf(Language)).isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RegionalSettingsInlineLanguageSelector.defaultProps = {
  disabled: false,
};

export default observer(RegionalSettingsInlineLanguageSelector);
